import React, { useState, useEffect } from "react";
import { 
  collection, 
  getDocs, 
  addDoc, 
  doc, 
  updateDoc, 
  deleteDoc, 
  query, 
  where, 
  runTransaction 
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import "./ProposalsDCS.css";
import "./ProposalsDynasty.css";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { serverTimestamp } from "firebase/firestore";

const DCSSentProposals = () => {
  const [proposals, setProposals] = useState([]);
  const [properties, setProperties] = useState([]);
  const [users, setUsers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [newProposal, setNewProposal] = useState({
    companyName: "",
    companyAddress: "",
    companyCityStateZip: "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    scope: "",
    jobDescription: "",
    price: "", // Replaced Option A, B, C Price with a single price field
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",     // <-- NEW
    warranty: "",         // (text body stays here)
  });
  const [proposalID, setProposalID] = useState(3000);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [pdfDownloadUrl, setPdfDownloadUrl] = useState(""); // Add state for PDF download URL
  const navigate = useNavigate();
   
  const goToApproved = () => {
    navigate("/DCSApprovedProposals");
  };
  
  const goToCompleted = () => {
    navigate("/DCSCompletedProposals");
  };

  const goToSentProposals = () => {
    navigate("/DCSSentProposals");
  };

  const goToProposals = () => {
    navigate("/ProposalsDCS");
  };

  const goToProposalsJMC = () => {
    navigate("/ProposalsJMC");
  };

  const [sortOrder, setSortOrder] = useState("asc");

// Helpers
const formatInitials = (nameOrFirstLast) => {
  if (!nameOrFirstLast) return "";
  // Accept either "First Last" or already-initials and normalize to "F L"
  const parts = String(nameOrFirstLast).trim().split(/\s+/);
  const first = parts[0]?.[0] || "";
  const last  = parts[1]?.[0] || "";
  return [first, last].filter(Boolean).join(" ");
};

const formatDateMMDDYYYY = (isoOrYmd) => {
  if (!isoOrYmd) return "";
  // Handles "YYYY-MM-DD" from <input type="date"> or full ISO strings
  const d = new Date(isoOrYmd);
  if (Number.isNaN(d.getTime())) return isoOrYmd; // fallback
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${mm}-${dd}-${yyyy}`;
};

  const termsOptions = [
    { name: "Half & Half (Commonly used)", content: "A deposit of 50% of the total amount is required upon acceptance of the proposal. The remaining balance will be invoiced upon completion of the work. Payment is due upon receipt of the invoice." },
    { name: "1/3 & Progress (Maryland must use)", content: "A deposit of (1/3) of the total contract amount is required upon proposal acceptance. The remaining balance will be invoiced in progress payments until completion, with final payment due upon project completion." },
    { name: "1/2 & Progress (recommened for large projects)", content: "A deposit of (1/2) of the total contract amount is required upon proposal acceptance. The remaining balance will be invoiced in progress payments until completion, with final payment due upon project completion." },
    { name: "1/3 & 1/3 (Maryland Must Use)", content: "A deposit of (1/3) of the total contract amount is required upon proposal acceptance, (1/3) is required before beginnig work, the remaining balance will be invoiced in progress payments until completion, with final payment due upon project completion." },
  ];

  const logoOptions = [
    { name: "Dynasty Community Services", url: "https://firebasestorage.googleapis.com/v0/b/servicing-head-quarters.firebasestorage.app/o/images%2Fdcslogoblack.jpg?alt=media&token=a4cace1b-090d-4888-b725-9c964e3f1f8b", alignment: "left" }
    
  ];

  const JMC_NAME = "Dynasty Community Services";

  const [selectedLogo, setSelectedLogo] = useState(logoOptions[0]);

  const handleLogoChange = (e) => {
    const selected = logoOptions.find(option => option.name === e.target.value);
    setSelectedLogo(selected);
  };

  const [warrantyOptions] = useState([
    {
      name: "Standard Warranty",
      content: ({ companyName, siteName }) => `
  ${companyName} guarantees all material to be as specified and all work to be completed in a workmanlike manner according to standard practices. Any alteration or deviation from the above specifications involving extra costs will be performed only upon a written change order, and such costs will become an additional charge over and above the original contract price. No guarantees are expressed or implied regarding the effectiveness of the work. Performance may be delayed by circumstances beyond the contractor’s control, including but not limited to weather, strikes, or any other acts not controlled by ${companyName}.
  
  ${companyName} performs all work under the guidelines of the state and/or county where work is being performed and complies with all applicable permit requirements. If permits are required to be pulled, the cost of those permits shall be the responsibility of ${siteName}.
  
  ${companyName} is not responsible for direct or incidental damage to any items such as (but not limited to) hoses, sprinklers, underground wiring systems, or loss of any nature to property, except in cases of willful misconduct or gross negligence. Any damage or suspected damage must be reported to the contractor within 48 hours for consideration. If ${companyName} assumes responsibility, an opportunity must be provided for the contractor to correct the damage. Proposal pricing does not include alterations of the scope of work due to buried or concealed obstacles. The Client shall be responsible for the procurement of all permits and approvals required. Any requested or required construction specifications that alter the scope of work specified in the contract will result in a change in pricing to complete the work.
  
  Deposits are strictly non-refundable. Once a proposal is approved (whether by email, written signature, or other authorization), the Client acknowledges that the work cannot be transferred to another vendor without the written consent of ${companyName}. Attempting to cancel or assign the work to another contractor without such consent shall be considered a breach of contract.
  
  ${companyName} is proud to provide a One-Year Limited Workmanship Warranty, guaranteeing the quality of workmanship provided to our valued customers ("Client"). For a period of twelve (12) months from the completion date of the work performed under this contract, ${companyName} warrants against defects in workmanship of the installation.
  
  This warranty does not cover damages or failure of products caused by: structural defects, settlement or failure; improper drainage (standing water); fire, explosion, chemicals, fumes, vapors; or damage caused in whole or in part by acts of God, flooding, extreme weather, vandalism, negligence, or any other similar causes beyond the control of ${companyName}.
  
  This warranty is applicable only to ${siteName}.
      `.trim()
    },
    {
      name: "No Warranty (Use for Homeowners work)",
      content: () => "" // nothing; we'll hide the section
    }
  ]);

  const handleWarrantyChange = (e) => {
    const name = e.target.value;
    const found = warrantyOptions.find(opt => opt.name === name);
    if (!found) return;
  
    const text = found.content({
      companyName: newProposal.companyName || selectedProposal?.companyName || "",
      siteName: newProposal.siteName || selectedProposal?.siteName || ""
    });
  
    setNewProposal(prev => ({
      ...prev,
      warrantyName: name,
      warranty: text
    }));
  };

  useEffect(() => {
    const fetchProposals = async () => {
      const proposalsRef = collection(db, "proposals");
    
      // ONLY pull proposals for DCS
      const q = query(
        proposalsRef,
        where("companyName", "==", "Dynasty Community Services")
      );
    
      const querySnapshot = await getDocs(q);
    
      const proposalsData = querySnapshot.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(p => p.status === "Sent");
    
      setProposals(proposalsData);
    };

    const fetchProperties = async () => {
      const propertiesRef = collection(db, "properties");
      const querySnapshot = await getDocs(propertiesRef);
      const propertiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setProperties(propertiesData);
    };

    const fetchUsers = async () => {
      const usersRef = collection(db, "users");
      const querySnapshot = await getDocs(usersRef);
      const usersData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setUsers(usersData);
    };

    const fetchCompanies = async () => {
      const companiesRef = collection(db, "companies");
      const querySnapshot = await getDocs(companiesRef);
      const companiesData = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCompanies(companiesData);
    };

    fetchProposals();
    fetchProperties();
    fetchUsers();
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        scope: selectedProposal.scope || "",
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warrantyName: selectedProposal.warrantyName || "",  // <-- NEW
        warranty: selectedProposal.warranty || "",          // text
      });
    }
  }, [selectedProposal]);

  const sortedProperties = properties.sort((a, b) => a.propertyName.localeCompare(b.propertyName));

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProposal((prev) => ({ ...prev, [name]: value }));
  };

  const handleCompanyNameChange = (e) => {
    const selectedCompany = companies.find(company => company.companyName === e.target.value);
    const matchedLogo = logoOptions.find(logo => logo.name === selectedCompany.companyName);
    setNewProposal((prev) => ({
      ...prev,
      companyName: selectedCompany.companyName,
      companyAddress: selectedCompany.companyAddress || "",
      companyCityStateZip: `${selectedCompany.companyCity}, ${selectedCompany.companyState} ${selectedCompany.companyZip}` || ""
    }));
    if (matchedLogo) {
      setSelectedLogo(matchedLogo);
    }
  };

  const handleSiteNameChange = (e) => {
    const selectedProperty = properties.find(property => property.propertyName === e.target.value);
    setNewProposal((prev) => ({
      ...prev,
      siteName: selectedProperty.propertyName,
      management: selectedProperty.management || "",
      managerName: selectedProperty.managerName || "",
      address: selectedProperty.address || selectedProperty.managementAddress || "",
      cityStateZip: `${selectedProperty.city || selectedProperty.managementCity}, ${selectedProperty.state || selectedProperty.managementState} ${selectedProperty.zip || selectedProperty.managementZip}` || ""
    }));
  };

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setNewProposal(prevState => ({
      ...prevState,
      images: [...prevState.images, ...selectedFiles], // Append new files without removing URLs
    }));
  };
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { images, ...proposalData } = newProposal;
      const proposalDocRef = await addDoc(collection(db, "proposals"), {
        ...proposalData,
        status: "Not Sent",
        hasBeenSent: false
      });
      let imageURLs = [];
      if (images.length > 0) {
        const storage = getStorage();
        const uploadPromises = images.map(async (file) => {
          const storageRef = ref(storage, `proposals/${proposalDocRef.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
        imageURLs = await Promise.all(uploadPromises);
        await updateDoc(proposalDocRef, { imageURLs });
      }

      setProposals([...proposals, { id: proposalDocRef.id, ...proposalData, imageURLs }]);
      setProposalID(proposalID + 1);
      setNewProposal({
        companyName: "",
        companyAddress: "",
        companyCityStateZip: "",
        siteName: "",
        management: "",
        managerName: "",
        address: "",
        cityStateZip: "",
        scope: "",
        jobDescription: "",
        price: "",
        submittedDate: "",
        submittedBy: "",
        images: [],
        terms: "",
        warranty: "",
      });
      setIsEditing(false);
    } catch (error) {
      console.error("Error adding proposal:", error);
    }
  };

  const handleEditProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
  
      // Extract files from newProposal.images
      const files = newProposal.images.filter(img => img instanceof File);
      let imageURLs = selectedProposal.imageURLs || []; // Keep existing URLs
  
      if (files.length > 0) {
        const storage = getStorage();
        const uploadPromises = files.map(async (file) => {
          const storageRef = ref(storage, `proposals/${selectedProposal.id}/${file.name}`);
          await uploadBytes(storageRef, file);
          return await getDownloadURL(storageRef);
        });
  
        const uploadedImageURLs = await Promise.all(uploadPromises);
        imageURLs = [...imageURLs, ...uploadedImageURLs]; // Merge new and old URLs
      }
  
      // Update Firestore (store URLs, not files)
      await updateDoc(proposalRef, { 
        ...newProposal, 
        images: imageURLs 
      });
  
      // Update UI
      setProposals(proposals.map(proposal => 
        proposal.id === selectedProposal.id ? { ...proposal, images: imageURLs } : proposal
      ));
  
      setSelectedProposal({ ...selectedProposal, images: imageURLs });
      setIsEditing(false);
    } catch (error) {
      console.error("Error updating proposal:", error);
    }
  };
  

  const handleDeleteProposal = async () => {
    try {
      const proposalRef = doc(db, "proposals", selectedProposal.id);
      await deleteDoc(proposalRef);
      setProposals(proposals.filter(proposal => proposal.id !== selectedProposal.id));
      setSelectedProposal(null);
      setShowDeleteConfirm(false);
    } catch (error) {
      console.error("Error deleting proposal:", error);
    }
  };

  const handleCancel = () => {
    setNewProposal({
      companyName: "",
      companyAddress: "",
      companyCityStateZip: "",
      siteName: "",
      management: "",
      managerName: "",
      address: "",
      cityStateZip: "",
      scope: "",
      jobDescription: "",
      price: "",
      submittedDate: "",
      submittedBy: "",
      images: [],
      terms: "",
      warranty: "",
    });
    setIsEditing(false);
  };

  const parseJobDescription = (description) => {
    if (!description) return null;
    return description.split('\n').map((line, index) => {
      if (line.startsWith('((b))')) {
        return <p key={index} className="bold">{line.replace('((b))', '')}</p>;
      } else if (line.startsWith('((i))')) {
        return <p key={index} className="italic">{line.replace('((i))', '')}</p>;
      } else if (line.startsWith('((-))')) {
        return <li key={index} className="bullet">{line.replace('((-))', '')}</li>;
      } else {
        return <p key={index}>{line}</p>;
      }
    });
  };

  const handleEditClick = () => {
    if (selectedProposal) {
      setNewProposal({
        companyName: selectedProposal.companyName || "",
        companyAddress: selectedProposal.companyAddress || "",
        companyCityStateZip: selectedProposal.companyCityStateZip || "",
        siteName: selectedProposal.siteName || "",
        management: selectedProposal.management || "",
        managerName: selectedProposal.managerName || "",
        address: selectedProposal.address || "",
        cityStateZip: selectedProposal.cityStateZip || "",
        scope: selectedProposal.scope || "",
        jobDescription: selectedProposal.jobDescription || "",
        price: selectedProposal.price || "",
        submittedDate: selectedProposal.submittedDate || "",
        submittedBy: selectedProposal.submittedBy || "",
        images: selectedProposal.images || [],
        terms: selectedProposal.terms || "",
        warranty: selectedProposal.warranty || "",
      });
      setIsEditing(true);
    }
  };
  
  // Put this above your component or inside it before return
  const openPrintPreview = () => {
    const printable = document.getElementById("printableArea");
    if (!printable) return;
  
    // Create hidden iframe
    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";
    iframe.setAttribute("aria-hidden", "true");
    document.body.appendChild(iframe);
  
    const doc = iframe.contentWindow || iframe.contentDocument;
    const iDoc = doc.document || doc;
  
    const content = printable.outerHTML;
    const printCss = `
  <style>
   <style>
  /* Paper */
  @page {
    size: Letter;
    margin: 0.5in;
  }
  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    color: #111;
    font: 12pt/1.35 -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
    background: #f5f7fb;
  }

  /* Hide app controls in print */
    @media print { .no-print { display: none !important; } }

    /* Make the layout single-column in print (so it can break naturally) */
    @media print {
      .row-container {
        display: block !important;        /* kill flex for print */
      }
      .row-container > * {
        width: 100% !important;           /* each card full-width in order */
      }
    }

    /* Section cards — allow breaking through them */
    .companyinfo-container,
    .property-container,
    .scope-container,
    .description-container,
    .total-container,
    .image-container,
    .terms-container,
    .warranty-container,
    .acceptance-container,
    .noteacceptance-container {
      border: 1px solid #999 !important;
      border-radius: 6px;
      padding: 12px;
      background: #fff !important;
      box-shadow: none !important;
      margin-bottom: 12px;

      /* ✨ Let sections split across pages if they are tall */
      break-inside: auto !important;
      page-break-inside: auto !important;
      overflow: visible !important;
    }

    /* Text tweaks */
    .companyinfo-container p,
    .property-container p,
    .scope-container p,
    .description-container p,
    .total-container p,
    .terms-container p,
    .warranty-container p,
    .noteacceptance-container p,
    .acceptance-container p {
      margin: 4px 0;
      font-size: 10.5pt;
      line-height: 1.3;
      word-break: break-word;
      overflow-wrap: anywhere;
    }

  /* ---------- Global Containers (match Details look) ---------- */
  .page-border {
    border: 1px solid rgba(200, 200, 200, 0.6) !important;
    border-radius: 6px;
    padding: 20px;
    margin: 20px auto;
    background: rgba(255, 255, 255, 0.98) !important;
    max-width: 900px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
  }

  .row-container {
    display: flex !important;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 20px;
  }

  .bordered-box {
    border: 1px solid rgba(200, 200, 200, 0.6) !important;
    border-radius: 6px;
    padding: 15px;
    background: rgba(255, 255, 255, 0.95) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    break-inside: avoid-page;
    page-break-inside: avoid;
    margin-bottom: 16px;
  }

  .companyinfo-container,
.property-container {
  flex: 1.2; /* instead of flex: 1 */
  line-height: .5; 
}

  /* Specific containers (all get lighter style now) */
  .companyinfo-container,
  .property-container,
  .scope-container,
  .description-container,
  .total-container,
  .image-container,
  .terms-container, 
  .warranty-container {
    border: 1px solid rgba(200, 200, 200, 0.6) !important;
    border-radius: 6px;
    padding: 15px;
    background: rgba(255, 255, 255, 0.95) !important;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05) !important;
    margin-bottom: 16px;
  }


  .scope-container p,
  .description-container p,
  .terms-container p,
  .warranty-container p { font-size: 13px; text-align: center; margin: 4px 0; }

  .total-container p { font-size: 15px; text-align: center; margin: 4px 0; }
  .total-text { white-space: pre-line; line-height: 1.35; font-size: 11pt; }

  /* Warranty paragraph indent */
  .warranty-container p { text-indent: 2em; }

  /* NOTE / Acceptance */
  .noteacceptance-container,
  .acceptance-container,
  .signature-row {
    text-align: center;
    margin-bottom: 20px;
    display: block;
  }
  .noteacceptance-container p,
  .acceptance-container p,
  .signature-row p { font-size: 12px; margin: 4px 0; }

  /* Job description formatting */
  .job-bullet { display: block; margin-left: 10px; }
  .job-bold   { font-weight: 700; }
  .job-italic { font-style: italic; }

  /* Logo */
  .companylogo-container { text-align: center; margin: 0 0 12px 0; }
  .companylogo-container img.resizable-logo {
    max-width: 20% !important; height: auto !important; display: inline-block;
  }

  /* Images grid (match Details) */
  .image-container {
    border: 1px solid rgba(210, 210, 210, 0.6) !important;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 20px;
    background: rgba(255,255,255,.95) !important;
    box-shadow: 0 2px 4px rgba(0,0,0,.05) !important;
    text-align: center;
  }
  .image-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }
  .image-wrapper {
    width: 150px; height: 150px;
    display: flex; justify-content: center; align-items: center;
    overflow: hidden;
    border: 1px solid rgba(200,200,200,0.6);
    border-radius: 5px;
    background: #fafafa;
    break-inside: avoid; page-break-inside: avoid;
  }
  .proposal-image { width: 100%; height: 100%; object-fit: contain; }

  /* Page break utility */
  .page-break { break-before: page; page-break-before: always; }

  /* PRINT overrides to force the same “card” look */
  @media print {
    .page-border,
    .companyinfo-container,
    .property-container,
    .scope-container,
    .description-container,
    .total-container,
    .image-container,
    .terms-container,
    .warranty-container {
      border: 1px solid rgba(200, 200, 200, 0.6) !important;
      background: #fff !important;
      box-shadow: 0 1px 2px rgba(0,0,0,.04) !important;
    }

    /* KEEP the two-column row in print */
    .row-container { display: flex !important; }
    .row-container > * { width: auto !important; }

    /* Keep cards intact */
    .companyinfo-container,
    .property-container,
    .scope-container,
    .description-container,
    .total-container,
    .image-container,
    .terms-container,
    .warranty-container {
      break-inside: avoid-page;
      page-break-inside: avoid;
    }
  }
</style>
`;


  
    iDoc.open();
    iDoc.write(`
      <!doctype html>
      <html>
        <head>
          <meta charset="utf-8" />
          <title>Proposal</title>
          ${printCss}
        </head>
        <body>
          ${content}
        </body>
      </html>
    `);
    iDoc.close();
  
    const doPrint = () => {
      try { (iframe.contentWindow || iframe).focus(); } catch {}
      try { (iframe.contentWindow || iframe).print(); } catch {}
      // Clean up after a bit
      setTimeout(() => {
        try { document.body.removeChild(iframe); } catch {}
      }, 1000);
    };
  
    if ((iframe.contentDocument || iframe).readyState === "complete") {
      setTimeout(doPrint, 150);
    } else {
      iframe.onload = () => setTimeout(doPrint, 150);
    }
  };
  


  const handlePrint = async () => {
    if (!selectedProposal) return;
  
    // 1) Open the print preview immediately (keeps user gesture intact)
    openPrintPreview();
  
    // 2) Then do your PDF creation + upload in the background of this handler
    try {
      const now = new Date();
      const timestamp = now.toISOString();
      const formattedTimestamp = now.toISOString().replace(/[-T:]/g, "").split(".")[0];
      const proposalPDFname = `${selectedProposal.siteName} ${selectedProposal.scope} ${formattedTimestamp}.pdf`.replace(/[/\\?%*:|"<>]/g, "");
  
      // Create a simple PDF (or call your generatePDF(proposal) if preferred)
      const doc = new jsPDF();
      doc.text(`Proposal for ${selectedProposal.siteName}`, 10, 10);
      doc.text(`Scope: ${selectedProposal.scope}`, 10, 20);
      doc.text(`Submitted By: ${formatInitials(selectedProposal.submittedBy)} on ${formatDateMMDDYYYY(selectedProposal.submittedDate)}`, 10, 30);
  
      const pdfBlob = doc.output("blob");
  
      const storage = getStorage();
      const pdfRef = ref(storage, `proposals/${selectedProposal.id}/pdfs/${proposalPDFname}`);
  
      await uploadBytes(pdfRef, pdfBlob);
      const downloadURL = await getDownloadURL(pdfRef);
      setPdfDownloadUrl(downloadURL);
  
      // Record in subcollection
      const proposalPdfsRef = collection(db, `proposals/${selectedProposal.id}/pdfs`);
      await addDoc(proposalPdfsRef, {
        proposalPDF: downloadURL,
        proposalPDFname,
        timestamp,
        dateTimeString: now.toLocaleString(),
      });
  
      // Associate to job if match exists
      await matchAndAddPdfToJob(
        selectedProposal.siteName,
        selectedProposal.scope,
        downloadURL,
        proposalPDFname,
        timestamp,
        now.toLocaleString()
      );
  
      // Optional: auto-open the saved PDF in a new tab so they can print the real PDF too
      // window.open(downloadURL, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Error uploading PDF:", err);
      // Optional non-blocking UI feedback here
    }
  };
  
  
  const matchAndAddPdfToJob = async (siteName, scope, pdfURL, pdfName, timestamp, dateTimeString) => {
    try {
      // Fetch jobs collection
      const jobsRef = collection(db, "jobs");
      const querySnapshot = await getDocs(jobsRef);
  
      // Find a job that matches the siteName and scope
      const matchingJobDoc = querySnapshot.docs.find(
        (doc) => doc.data().siteName === siteName && doc.data().scope === scope
      );
  
      if (matchingJobDoc) {
        const jobId = matchingJobDoc.id;
        const jobRef = doc(db, "jobs", jobId);
  
        // Get existing PDFs array or initialize a new one
        const existingJobData = matchingJobDoc.data();
        const existingPdfs = existingJobData.proposalPdfs || [];
  
        // Add the new PDF to the array
        const updatedPdfs = [...existingPdfs, { pdfURL, pdfName, timestamp, dateTimeString }];
  
        // Update Firestore with the new PDF
        await updateDoc(jobRef, { proposalPdfs: updatedPdfs });
  
        console.log(`PDF successfully added to job with ID: ${jobId}`);
      } else {
        console.warn(`No matching job found for Site: ${siteName}, Scope: ${scope}`);
      }
    } catch (error) {
      console.error("Error updating job with PDF:", error);
    }
  };
  
const getImageData = async (url) => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

const generatePDF = async (proposal, fontSize = 12, termsFontSize = 12, termsFontStyle = 'normal') => {
    const doc = new jsPDF();
    doc.setFontSize(fontSize);
    
    // Add border
    doc.rect(10, 10, 190, 277);

    // Logo container
    doc.setDrawColor(0);
    doc.setFillColor(255, 255, 255);
    doc.rect(15, 20, 180, 30, 'FD');
    doc.text("Logo:", 20, 30);
    if (proposal.logo) {
        const logoImage = await getImageData(proposal.logo);
        doc.addImage(logoImage, 'JPEG', 20, 35, 50, 15);
    }

    let yOffset = 60;

    // Company container
    doc.setFillColor(255, 255, 255);
    const companyHeight = 10 + (proposal.companyName ? 10 : 0) + (proposal.companyAddress ? 10 : 0) + (proposal.companyCityStateZip ? 10 : 0);
    doc.rect(15, yOffset, 180, companyHeight, 'FD');
    doc.text("Company:", 20, yOffset + 10);
    if (proposal.companyName) doc.text(proposal.companyName, 105, yOffset + 20, { maxWidth: 170, align: 'center' });
    if (proposal.companyAddress) doc.text(proposal.companyAddress, 105, yOffset + 30, { maxWidth: 170, align: 'center' });
    if (proposal.companyCityStateZip) doc.text(proposal.companyCityStateZip, 105, yOffset + 40, { maxWidth: 170, align: 'center' });
    yOffset += companyHeight + 10;

    // Site container
    const siteHeight = 10 + (proposal.siteName ? 10 : 0) + (proposal.management ? 10 : 0) + (proposal.managerName ? 10 : 0) + (proposal.address ? 10 : 0);
    doc.rect(15, yOffset, 180, siteHeight, 'FD');
    doc.text("Site:", 20, yOffset + 10);
    if (proposal.siteName) doc.text(`Site: ${proposal.siteName}`, 20, yOffset + 20, { maxWidth: 170 });
    if (proposal.management) doc.text(`Management: ${proposal.management}`, 20, yOffset + 30, { maxWidth: 170 });
    if (proposal.managerName) doc.text(`Manager: ${proposal.managerName}`, 20, yOffset + 40, { maxWidth: 170 });
    if (proposal.address) doc.text(`Address: ${proposal.address}`, 20, yOffset + 50, { maxWidth: 170 });
    yOffset += siteHeight + 10;

    // Scope container
    const scopeHeight = 20;
    doc.rect(15, yOffset, 180, scopeHeight, 'FD');
    doc.text("Scope:", 20, yOffset + 10);
    doc.text(proposal.scope || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += scopeHeight + 10;

    // Job Description container
    const jobDescriptionLines = (proposal.jobDescription || '').split('\n');
    const jobDescriptionText = jobDescriptionLines.map(line => `• ${line}`).join('\n');
    const jobDescriptionHeight = jobDescriptionLines.length * 10 + 10; // Adjust height based on line count

    doc.rect(15, yOffset, 180, jobDescriptionHeight, 'FD'); // Single container
    doc.text("Job Description:", 20, yOffset + 10);
    doc.text(jobDescriptionText, 20, yOffset + 20, { maxWidth: 170, align: 'left' });

    yOffset += jobDescriptionHeight + 10; // Adjust for next section

    // Total Price container
    const totalPriceHeight = 20;
    doc.rect(15, yOffset, 180, totalPriceHeight, 'FD');
    doc.text("Total Price:", 20, yOffset + 10);
    doc.text(`$${proposal.price || ''}`, 20, yOffset + 20, { maxWidth: 170 });
    yOffset += totalPriceHeight + 10;

    // Options container
    if (proposal.options && proposal.options.length > 0) {
        doc.addPage();
        yOffset = 10;
        const optionsHeight = 20 + proposal.options.length * 10;
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, optionsHeight, 'FD');
        doc.text("Options:", 20, yOffset + 10);
        proposal.options.forEach((option, index) => {
            doc.text(`Option ${String.fromCharCode(65 + index)} Total: ${option}`, 20, yOffset + 20 + index * 10, { maxWidth: 170 });
        });
        yOffset += optionsHeight + 10;
    }

    // Additional Note container
    doc.addPage();
    yOffset = 10;
    const additionalNoteHeight = 30;
    doc.setFillColor(255, 255, 255);
    doc.rect(15, yOffset, 180, additionalNoteHeight, 'FD');
    doc.text("Additional Note:", 20, yOffset + 10);
    doc.text(proposal.additionalNote || '', 20, yOffset + 20, { maxWidth: 170 });
    yOffset += additionalNoteHeight + 10;

    // Image Upload container
    if (proposal.images && proposal.images.length > 0) {
        doc.addPage();
        yOffset = 10;
        const imagesHeight = 20 + Math.ceil(proposal.images.length / 3) * 110; // Adjust height based on image count
        doc.setFillColor(255, 255, 255);
        doc.rect(15, yOffset, 180, imagesHeight, 'FD');
        doc.text("Images:", 20, yOffset + 10);
        for (const [index, imageUrl] of proposal.images.entries()) {
            const imageData = await getImageData(imageUrl);
            const x = 20 + (index % 3) * 60; // Adjust x position for 3 images per row
            const y = yOffset + 20 + Math.floor(index / 3) * 100; // Adjust y position for each row
            doc.addImage(imageData, 'JPEG', x, y, 50, 50); // Adjust
        }
        yOffset += imagesHeight + 10;
    }

    // Add page break for terms
    doc.addPage();
    yOffset = 10;
    doc.rect(10, 10, 190, 277);
    
    // Terms & Conditions
    doc.setFontSize(termsFontSize);
    doc.setFont('helvetica', termsFontStyle);
    doc.text("Terms & Conditions:", 15, yOffset + 10);

    // Handle line breaks in terms
    const termsLines = (proposal.terms || '').split('\n');
    yOffset += 20;
    termsLines.forEach(line => {
        doc.text(line, 15, yOffset, { maxWidth: 180 });
        yOffset += 10;
    });
    
    // Save PDF
    const filename = `${proposal.siteName} ${proposal.scope}`.replace(/[/\\?%*:|"<>]/g, '') + '.pdf';
doc.save(filename);
};

const generateAndUploadPDF = async () => {
    const doc = new jsPDF();
    doc.text("This is a dynamically created PDF stored in Firebase!", 10, 10);
    const pdfBlob = doc.output("blob");

    const storage = getStorage();
    const pdfRef = ref(storage, `generated_pdfs/my_generated_pdf.pdf`);

    try {
      const snapshot = await uploadBytes(pdfRef, pdfBlob);
      const downloadURL = await getDownloadURL(snapshot.ref);
      console.log("PDF uploaded successfully:", downloadURL);

      document.getElementById("pdfLink").href = downloadURL;
      document.getElementById("pdfLink").innerText = "Download Generated PDF";
      document.getElementById("pdfViewer").src = downloadURL;
    } catch (error) {
      console.error("Error uploading PDF:", error);
    }
  };

const handleAddProposalClick = () => {
  const jmc = companies.find(c => c.companyName === JMC_NAME);
  setNewProposal({
    companyName: JMC_NAME,
    companyAddress: jmc?.companyAddress || "",
    companyCityStateZip: jmc ? `${jmc.companyCity}, ${jmc.companyState} ${jmc.companyZip}` : "",
    siteName: "",
    management: "",
    managerName: "",
    address: "",
    cityStateZip: "",
    scope: "",
    jobDescription: "",
    price: "",
    submittedDate: "",
    submittedBy: "",
    images: [],
    terms: "",
    warrantyName: "",
    warranty: "",
  });
  // ensure the JMC logo is selected
  setSelectedLogo(logoOptions[0]);
  setIsEditing(true);
};


const handleCloseDetails = () => {
  setSelectedProposal(null);
};

const handleDeleteProposalDirect = async (proposalId) => {
  try {
    const proposalRef = doc(db, "proposals", proposalId);
    await deleteDoc(proposalRef);
    setProposals(prev => prev.filter(p => p.id !== proposalId));
  } catch (error) {
    console.error("Error deleting proposal:", error);
    alert("Failed to delete proposal.");
  }
};

const handleMarkCompleted = async (proposal) => {
  try {
    const proposalRef = doc(db, "proposals", proposal.id);

    await updateDoc(proposalRef, {
      status: "Completed"
    });

    // update UI immediately
    setProposals(prev =>
      prev.filter(p => p.id !== proposal.id) // remove from Not Sent list
    );

    alert("Proposal marked as Completed.");
  } catch (error) {
    console.error("Error marking proposal as Completed:", error);
    alert("Could not update status.");
  }
};


const handleToggleStatus = async (proposal, type) => {
  const proposalRef = doc(db, "proposals", proposal.id);
  let newStatus = proposal.status;
  let hasBeenSent = proposal.hasBeenSent || false;

  if (type === "sent") {
    if (proposal.status === "Not Sent") {
      newStatus = "Sent";
      hasBeenSent = true;
    } else if (proposal.status === "Sent") {
      newStatus = "Not Sent";
      hasBeenSent = false;
    } else if (proposal.status === "Approved") {
      // Stay approved, but still allow toggling hasBeenSent
      hasBeenSent = !hasBeenSent;
    }
  } else if (type === "approval") {
    if (proposal.status === "Approved") {
      newStatus = "Sent"; // Toggle back
    } else {
      newStatus = "Approved";
      hasBeenSent = true; // Mark as sent when approved
    }
  }

  try {
    // 1) Update the proposal document
    await updateDoc(proposalRef, {
      status: newStatus,
      hasBeenSent
    });

    // 2) Reflect locally
    setProposals(prev =>
      prev.map(p =>
        p.id === proposal.id
          ? { ...p, status: newStatus, hasBeenSent }
          : p
      )
    );

    // 3) If it *just* became Approved, create/upsert a job
    if (proposal.status !== "Approved" && newStatus === "Approved") {
      // Include imageURLs if you have them on the proposal object in state
      // (your table rows look like they keep imageURLs on the object)
      await upsertJobFromProposal(proposal);
    }
  } catch (error) {
    console.error("Error updating status:", error);
    alert("Failed to update proposal status.");
  }
};

const getNextWorkOrder = async (prefix) => {
  const counterRef = doc(db, "counters", `${prefix}_jobs`);
  let nextNumber;

  await runTransaction(db, async (tx) => {
    const snap = await tx.get(counterRef);

    if (!snap.exists()) {
      // Use `create` so if another txn created it, this txn will retry
      tx.create(counterRef, { lastNumber: 10000, updatedAt: serverTimestamp() });
      nextNumber = 10001;
      // Move to a consistent state in the same txn
      tx.update(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    } else {
      const data = snap.data() || {};
      const last = Number(data.lastNumber);
      const safeLast = Number.isFinite(last) ? last : 10000;
      nextNumber = safeLast + 1;
      tx.update(counterRef, { lastNumber: nextNumber, updatedAt: serverTimestamp() });
    }
  });

  return `${prefix}-${nextNumber}`;
};

const handleSortBySite = () => {
  const sorted = [...proposals].sort((a, b) => {
    const nameA = a.siteName?.toLowerCase() || "";
    const nameB = b.siteName?.toLowerCase() || "";

    if (sortOrder === "asc") {
      return nameA.localeCompare(nameB);
    } else {
      return nameB.localeCompare(nameA);
    }
  });

  setProposals(sorted);
  setSortOrder(sortOrder === "asc" ? "desc" : "asc");
};


const upsertJobFromProposal = async (proposal) => {
  try {
    // 1) Do we already have a job tied to this proposal?
    const jobsRef = collection(db, "jobs");
    const q = query(jobsRef, where("proposalId", "==", proposal.id));
    const existing = await getDocs(q);

    const images =
      proposal.imageURLs && proposal.imageURLs.length
        ? proposal.imageURLs
        : proposal.images || [];

    if (!existing.empty) {
      // Already exists — just make sure it's Active
      const jobDoc = existing.docs[0];
      await updateDoc(doc(db, "jobs", jobDoc.id), { status: "Active" });
      return jobDoc.id;
    }

    // 2) Create a Work Order # based on timestamp
    const ts = new Date();
    const wo = await getNextWorkOrder("PDCS");
    await updateDoc(doc(db, "proposals", proposal.id), { wo });
    setProposals(prev =>
      prev.map(p => p.id === proposal.id ? { ...p, wo } : p)
    );
    
    // 3) Build job record
    const jobData = {
      proposalId: proposal.id,
      companyName: proposal.companyName || "",
      companyAddress: proposal.companyAddress || "",
      companyCityStateZip: proposal.companyCityStateZip || "",
      siteName: proposal.siteName || "",
      management: proposal.management || "",
      managerName: proposal.managerName || "",
      address: proposal.address || "",
      cityStateZip: proposal.cityStateZip || "",
      scope: proposal.scope || "",
      jobDescription: proposal.jobDescription || "",
      price: proposal.price || "",
      submittedDate: proposal.submittedDate || "",
      submittedBy: proposal.submittedBy || "",
      terms: proposal.terms || "",
      warrantyName: proposal.warrantyName || "",
      warranty: proposal.warranty || "",
      images,
      wo,
      status: "Active",
      createdAt: ts.toISOString(),
    };

    // 4) Add job
    const newJobRef = await addDoc(jobsRef, jobData);
    return newJobRef.id;
  } catch (err) {
    console.error("upsertJobFromProposal error:", err);
    return null;
  }
};

  return (
    <div className="proposals-container">
      <div style={{ display: "flex", justifyContent: "right" }}>

</div>
      <h2 style={{margin:"0 0 12px 0", textAlign:"center"}}>DCS Sent Proposals</h2>
      
      {isEditing && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>{selectedProposal ? "Edit Proposal" : "Add Proposal"}</h3>
            <form className="form-container" onSubmit={handleSubmit}>
              <label>Logo:</label>
              <select name="logo" value={selectedLogo.name} onChange={handleLogoChange} required>
                {logoOptions.map(option => (
                  <option key={option.name} value={option.name}>{option.name}</option>
                ))}
              </select>
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
              <label>Job Description: (Notes: Add ((b)) for bold lines, add ((i)) for italic lines. Bold and italic lines, and spaces have no bullets.) </label>
              <textarea name="jobDescription" value={newProposal.jobDescription} onChange={handleInputChange}></textarea>
              <label>Job Description Preview:</label>
              <div className="job-description-preview">
                {parseJobDescription(newProposal.jobDescription)}
              </div>
              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>
              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button type="submit" className="blue-button">Save</button>
                <button type="button" className="red-button" onClick={() => setIsEditing(false)}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="table-container">
        <table>
          <thead>
            <tr>
            <th style={{ whiteSpace: "nowrap" }}>
  Site Name
  <button 
    onClick={handleSortBySite}
    style={{
      marginLeft: "6px",
      padding: "2px 6px",
      fontSize: "11px",
      cursor: "pointer"
    }}
  >
    {sortOrder === "asc" ? "▲" : "▼"}
  </button>
</th>
              <th>Scope</th>
              <th>Submitted Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {proposals.map(proposal => (
  <tr
  key={proposal.id}
  style={{
    backgroundColor:
      proposal.status === "Approved"
        ? "#d4edda" // green
        : proposal.status === "Sent"
        ? "#f8d7da" // pink
        : "transparent"
  }}
>
  <td>{proposal.siteName}</td>
  <td>{proposal.scope}</td>
  <td>{formatDateMMDDYYYY(proposal.submittedDate)}</td>
  <td>{formatInitials(proposal.submittedBy)}</td>
  <td>
  <button className="smalldetails-button" onClick={() => setSelectedProposal(proposal)}>Details</button>
  <button className="smalldelete-button" onClick={() => handleDeleteProposalDirect(proposal.id)} style={{ marginLeft: "8px" }}>Delete</button>
  <button
    className={`smallstatus-button ${proposal.status === "Approved" ? "approved" : ""}`}
    onClick={() => handleToggleStatus(proposal, "approval")}
    style={{ marginLeft: "8px" }}
  >
    {proposal.status === "Approved" ? "Approved" : "Not Approved"}
  </button>
  <button
    className={`smallstatus-button ${proposal.hasBeenSent ? "sent" : ""}`}
    onClick={() => handleToggleStatus(proposal, "sent")}
    style={{ marginLeft: "8px" }}
  >
    {proposal.hasBeenSent ? "Sent" : "Not Sent"}
  </button>
  <button
  className="smallcomplete-button"
  onClick={() => handleMarkCompleted(proposal)}
  style={{ marginLeft: "8px" }}
>
  Completed
</button>
</td>

</tr>

))}


          </tbody>
        </table>
      </div>

      {selectedProposal && (
        <div className="modal full-size-modal"> {/* Add full-size-modal class */}
          {isEditing ? (
            <div className="form-container shrink-form"> {/* Add shrink-form class */}
             <label>Company Name:</label>
<input
  type="text"
  name="companyName"
  value={newProposal.companyName}
  readOnly
/>


              <label>Company Address:</label>
              <input type="text" name="companyAddress" value={newProposal.companyAddress} onChange={handleInputChange} readOnly />
              <label>Company City, State, Zip:</label>
              <input type="text" name="companyCityStateZip" value={newProposal.companyCityStateZip} onChange={handleInputChange} readOnly />
              <label>Site Name:</label>
              <select name="siteName" value={newProposal.siteName} onChange={handleSiteNameChange} required>
                <option value="">Select Site Name</option>
                {sortedProperties.map(property => (
                  <option key={property.id} value={property.propertyName}>{property.propertyName}</option>
                ))}
              </select>
              <label>Management:</label>
              <input type="text" name="management" value={newProposal.management} onChange={handleInputChange} readOnly />
              <label>Manager Name:</label>
              <input type="text" name="managerName" value={newProposal.managerName} onChange={handleInputChange} readOnly />
              <label>Address:</label>
              <select name="address" value={newProposal.address} onChange={handleInputChange} required>
                <option value="">Select Address</option>
                {properties.map(property => (
                  <option key={property.id} value={property.address || property.managementAddress}>{property.address || property.managementAddress}</option>
                ))}
              </select>
              <label>City, State, Zip:</label>
              <select name="cityStateZip" value={newProposal.cityStateZip} onChange={handleInputChange} required>
                <option value="">Select City, State, Zip</option>
                {properties.map(property => (
                  <option key={property.id} value={`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}>{`${property.city || property.managementCity}, ${property.state || property.managementState} ${property.zip || property.managementZip}`}</option>
                ))}
              </select>
              <label>Scope:</label>
              <input type="text" name="scope" value={newProposal.scope} onChange={handleInputChange} required />
              <label>Job Description:</label>
<textarea
  name="jobDescription"
  value={newProposal.jobDescription}
  onChange={handleInputChange}
  rows={6}
/>

<label>Job Description Preview:</label>
<div className="job-description-preview">
  {newProposal.jobDescription.split("\n").map((line, index) => {
    if (line.trim() === "") {
      return <br key={index} />; // Preserve blank lines
    } else if (line.startsWith("((b))")) {
      return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
    } else if (line.startsWith("((i))")) {
      return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
    } else {
      return <span key={index} className="job-bullet">• {line} <br /></span>;
    }
  })}
</div>

              <label>Price:</label>
              <textarea
                name="price"
                value={newProposal.price}
                onChange={handleInputChange}
                rows={3}
                required
              ></textarea>
              <label>Submitted Date:</label>
              <input type="date" name="submittedDate" value={newProposal.submittedDate} onChange={handleInputChange} />
              <label>Submitted By:</label>
              <select
  name="submittedBy"
  value={newProposal.submittedBy}
  onChange={handleInputChange}
>
  <option value="">Select User</option>
  {users.map(user => {
    const initials = `${(user.firstName || "").charAt(0)} ${(user.lastName || "").charAt(0)}`.trim();
    return (
      <option key={user.id} value={initials}>
        {initials}
      </option>
    );
  })}
</select>

              <label>Image Display:</label>
              <input type="file" name="imageDisplay" onChange={handleFileChange} multiple />
              <label>Terms:</label>
              <select name="terms" value={newProposal.terms} onChange={handleInputChange} required>
                <option value="">Select Terms</option>
                {termsOptions.map(term => (
                  <option key={term.name} value={term.content}>{term.name}</option>
                ))}
              </select>
              <label>Warranty:</label>
              <select
                name="warrantyName"
                value={newProposal.warrantyName}
                onChange={handleWarrantyChange}
                required
              >
                <option value="">Select Warranty</option>
                {warrantyOptions.map(opt => (
                  <option key={opt.name} value={opt.name}>{opt.name}</option>
                ))}
              </select>
              <div className="modal-buttons">
                <button onClick={handleEditProposal} className="blue-button">Save</button>
                <button onClick={handleCancel} className="red-button">Cancel</button>
              </div>
            </div>
          ) : (
            <div id="printableArea" className="printable-content full-size-content"> {/* Add full-size-content class */}
              <div className="page-border">
                <div className="proposals-container">
                  {/* .companylogo-container */}
                  <div className="companylogo-container">
                    <img src={selectedLogo.url} alt="Company Logo" className={`resizable-logo ${selectedLogo.alignment}`} />
                  </div>

                  {/* .companyinfo-container and .property-container */}
                  <div className="row-container">
                  <div className="companyinfo-container bordered-box common-shadow">
  <p><strong>{selectedProposal.companyName}</strong></p>
  <p><strong>{selectedProposal.companyAddress}</strong></p>
  <p><strong>{selectedProposal.companyCityStateZip}</strong></p>
  <p><strong>info@dynastycommunityservices.com</strong></p>
  <p><strong>www.DynastyCommunityServices.com</strong></p>
</div>

                    <div className="property-container bordered-box">
                      <p><strong>{selectedProposal.siteName}</strong></p>
                      <p><strong>{selectedProposal.management}</strong></p>
                      <p><strong>{selectedProposal.address}</strong></p>
                      <p><strong>{selectedProposal.cityStateZip}</strong></p>
                    </div>
                  </div>

                  {/* .scope-container */}
                  <div className="scope-container bordered-box">
                    <p><strong>Scope of Work:</strong> {selectedProposal.scope}</p>
                  </div>

                  {/* .description-container */}
                  <div className="description-container bordered-box">
                    <p><strong>Description of work to be performed:</strong></p>
                    <p className="job-description">
                      {selectedProposal.jobDescription.split("\n").map((line, index) => {
                        if (line.trim() === "") {
                          return <br key={index} />;
                        } else if (line.startsWith("((b))")) {
                          return <span key={index} className="job-bold"><strong>{line.replace("((b))", "").trim()}</strong><br /></span>;
                        } else if (line.startsWith("((i))")) {
                          return <span key={index} className="job-italic"><i>{line.replace("((i))", "").trim()}</i><br /></span>;
                        } else {
                          return <span key={index} className="job-bullet">• {line} <br /></span>;
                        }
                      })}
                    </p>
                  </div>

                  {/* .total-container */}
                  <div className="total-container bordered-box common-shadow">
  <p className="total-text"><strong>{selectedProposal.price}</strong></p>
</div>

                  {/* .noteacceptance-container */}
              

                   {/* .acceptance-container */}
                   <div className="acceptance-container centered-text">
                   <p><i>This proposal is valid for 30 days from the date issued. By approving, the Client agrees to the described work and payment schedule. Unpaid balances will accrue a 5% monthly finance charge, and any additional costs identified during the work will be considered a change order and presented for approval before proceeding.</i></p>
                   <div style={{ height: "20px" }}></div> {/* spacer */}
                    <div className="signature-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                      <p><strong>Signature: ________________________________________________   Date: ____________________</strong></p>
                    </div>
                  </div>

                  {/* .image-container */}
                  {/* Only render image container if there are image URLs */}
{selectedProposal.imageURLs && selectedProposal.imageURLs.length > 0 && (
  <div className="image-container bordered-box">
    <div className="image-grid">
      {selectedProposal.imageURLs.map((imageUrl, index) => (
        <div key={index} className="image-wrapper">
          <img
            src={imageUrl}
            alt={`Uploaded ${index + 1}`}
            className="proposal-image"
          />
        </div>
      ))}
    </div>
  </div>
)}


                  {/* Add a page break before .terms-container */}

                  {/* .terms-container */}
                  <div className="terms-container bordered-box">
                    <p><strong>Payment Terms:</strong> {selectedProposal.terms}</p>
                  </div>

                  {/* .warranty-container */}
                  {selectedProposal.warrantyName !== "No Warranty" && selectedProposal.warranty && (
  <>
   
    <div className="warranty-container bordered-box">
      {selectedProposal.warranty.split("\n").map((line, i) => (
        <p key={i}>{line}</p>
      ))}
    </div>
  </>
)}

                </div>
              </div>



              <div className="no-print">
  <div className="modal-buttons">
    <button onClick={handlePrint} className="blue-button">Print/Download</button>
    <button onClick={() => setIsEditing(true)} className="blue-button">Edit</button>
    <button onClick={handleCloseDetails} className="green-button">Close</button>
    {pdfDownloadUrl && (
      <div style={{ marginTop: "10px" }}>
        <a
          href={pdfDownloadUrl}
          download
          target="_blank"
          rel="noopener noreferrer"
          className="blue-button"
        >
          Download PDF
        </a>
      </div>
    )}
  </div>
  <a id="pdfLink" href="#" target="_blank"></a>
  <iframe id="pdfViewer" width="100%" height="600px"></iframe>
</div>
</div>
          )}
        </div>
      )}

      {showDeleteConfirm && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Are you sure you want to delete?</h3>
            <div className="modal-buttons">
              <button onClick={handleDeleteProposal} className="red-button">Yes</button>
              <button onClick={() => setShowDeleteConfirm(false)} className="green-button">No</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DCSSentProposals;